// extracted by mini-css-extract-plugin
export default {"filterHeader":"IdentifierFilterModal_filterHeader__zelo6","root":"IdentifierFilterModal_root__CCFgO","container":"IdentifierFilterModal_container__oKe4a"};